/* eslint-disable lines-between-class-members */
import AuthService from './AuthService'
import CoursesService from './CourseService'
import MemberService from './MemberService'
import TicketService from './TicketService'
import CLosureService from './ClosureService'

class Api {
  ticket: TicketService
  member: MemberService
  course: CoursesService
  auth: AuthService
  closure: CLosureService

  constructor() {
    this.ticket = new TicketService()
    this.member = new MemberService()
    this.course = new CoursesService()
    this.auth = new AuthService()
    this.closure = new CLosureService()
  }
}

const API = new Api()

export default API
